export function url([first, ...strings], ...parameters) {
  return (
    first +
    parameters
      .map((key, index) => encodeURIComponent(key) + strings[index])
      .join('')
  );
}

export function toCamelCase(input) {
  return input
    .replace(/./, (text) => text.toLowerCase())
    .replaceAll(/_(.)/g, (_, initial) => initial.toUpperCase());
}

export function toSnakeCase(input) {
  return input.replace(/[A-Z]/, (text) => `_${text.toLowerCase()}`);
}

export function jsonKeyTransform(input, transform) {
  if (input instanceof Array) {
    return input.map((item) => jsonKeyTransform(item, transform));
  }

  if (input && typeof input === 'object') {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [
        transform(key),
        jsonKeyTransform(value, transform),
      ]),
    );
  }

  return input;
}
